import {requestMs} from "@helpers/api";

export const timeTracking = {
  getTimeTracking: (page, search, dateFrom, dateTo) => requestMs.get(`/api3/tracking?page=${page}${search}${dateFrom}${dateTo}`, {}),
  getTimeTrackingUser: (userId, page, dateFrom, dateTo) => requestMs.get(`/api3/user/${userId}/tracking?page=${page}${dateFrom}${dateTo}`, {}),
  startTimeTracking: () => requestMs.post('/api3/tracking/start', {}),
  stopTimeTracking: () => requestMs.post('/api3/tracking/stop', {}),
  getTimeTrackingDetails: ({userId, date}) => requestMs.get(`/api3/user/${ userId }/tracking/${ date }`, {})
};
